/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
import React, { useState, useEffect, useRef } from "react";
import {
  View,
  // TouchableOpacity,
  StyleSheet,
  // StatusBar,
  TouchableWithoutFeedback,
  Dimensions,
  ActivityIndicator,
} from "react-native";
// import Orientation from "react-native-orientation-locker";
import Video from "react-native-video";

import * as Animatable from "react-native-animatable";
import PlayerControls from "./PlayerControls";
// import { FullScreenOpen, FullScreenClose } from "./Icons";
import ProgressBar from "./ProgressBar";

const { height, width } = Dimensions.get("window");

const Player = ({
  videoLink = "",
  // navigation = {},
  showProgress = true,
  disablePunchSeek = false,
  pauseVideo = true,
  onClickHandle,
  onEnd,
  pausedEventTrack = () => {},
  resumedEventTrack = () => {},
  // showFullScreen = true,
}) => {
  const [state, setState] = useState({
    fullscreen: false,
    showControls: false,
    play: false,
    duration: 0,
    currentTime: 0,
  });

  const [buffering, setBuffering] = useState(false);

  const videoRef = useRef(null);

  useEffect(() => {
    if (pauseVideo) {
      setState((state) => ({
        ...state,
        play: false,
      }));
    }
  }, [pauseVideo]);

  useEffect(() => {
    if (!state.play) {
      setState((s) => ({ ...s, play: true }));
    }

    return () => {
      stopVideo();
    };
  }, []);

  const handleShowControls =
    onClickHandle ||
    (() => {
      setState((state) => ({
        ...state,
        showControls: !state.showControls,
      }));
    });

  useEffect(() => {
    let timeout = null;
    if (state.showControls) {
      timeout = setTimeout(() => {
        setState((state) => ({
          ...state,
          showControls: false,
        }));
      }, 5000);
    }
    () => {
      clearTimeout(timeout);
    };
  }, [state.showControls]);

  const handlePlayPause = (value = null) => {
    if (value) {
      setState((state) => ({
        ...state,
        play: value,
      }));
      resumedEventTrack();
      return;
    }
    setState((state) => ({
      ...state,
      play: !state.play,
    }));
    pausedEventTrack();
  };

  const handleOnLoad = (data) => {
    setState((state) => ({
      ...state,
      duration: data.duration,
      currentTime: data.currentTime,
    }));
  };

  const handleSkipForward = () => {
    const seek =
      state.currentTime + 15 >= state.duration
        ? state.duration
        : state.currentTime + 15;
    videoRef.current.seek(state.currentTime + 15);
    setState((state) => ({
      ...state,
      currentTime: seek,
    }));
  };

  const handleSkipBackward = () => {
    const seek = state.currentTime - 15 <= 0 ? 0 : state.currentTime - 15;
    videoRef.current.seek(state.currentTime - 15);
    setState((state) => ({
      ...state,
      currentTime: seek,
    }));
  };

  const onSeek = (data) => {
    videoRef.current.seek(data.seekTime);
    setState((state) => ({
      ...state,
      currentTime: data.seekTime,
    }));
  };

  const playAgain = (time) => {
    videoRef.current.seek(time);
    setState((state) => ({
      ...state,
      currentTime: time,
      play: true,
    }));
  };

  const onProgress = (data) => {
    setState((state) => ({
      ...state,
      currentTime: data.currentTime,
    }));
  };

  const stopVideo = () => {
    videoRef.current.seek(0);
    setState((state) => ({
      ...state,
      currentTime: 0,
      play: false,
    }));
  };

  return (
    <>
      <View
        style={[
          styles.conatiner,
          state.fullscreen
            ? {
                position: "absolute",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }
            : {},
          {
            justifyContent: "center",
          },
        ]}
      >
        <TouchableWithoutFeedback onPress={handleShowControls}>
          <View style={{ flex: 1 }}>
            <Video
              ref={(view) => {
                videoRef.current = view;
              }}
              source={{
                uri: videoLink,
              }}
              resizeMode="contain"
              style={state.fullscreen ? styles.fullScreenVideo : styles.video}
              onBuffer={({ isBuffering }) => setBuffering(isBuffering)}
              paused={!state.play}
              onLoad={handleOnLoad}
              onProgress={onProgress}
              onEnd={onEnd}
            />
            {buffering && (
              <View style={styles.buffering}>
                <ActivityIndicator />
              </View>
            )}
            {state.showControls && (
              <Animatable.View
                style={styles.controlOverlay}
                animation="fadeIn"
                duration={200}
                useNativeDriver={true}
              >
                <PlayerControls
                  isPlaying={state.play}
                  handlePlayPause={handlePlayPause}
                  skipForward={handleSkipForward}
                  skipBackword={handleSkipBackward}
                  showPreviousAndNext={false}
                  isCompleted={
                    Number(state.currentTime).toFixed(0) ===
                    Number(state.duration).toFixed(0)
                  }
                  playAgain={playAgain}
                  disablePunchSeek={disablePunchSeek}
                  showFullScreen={state.fullscreen}
                />
                {showProgress && (
                  <ProgressBar
                    currentTime={state.currentTime}
                    duration={state.duration}
                    onSlideCapture={onSeek}
                    handlePlayPause={handlePlayPause}
                    fullScreen={state.fullscreen}
                  />
                )}
              </Animatable.View>
            )}
          </View>
        </TouchableWithoutFeedback>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  conatiner: {
    flex: 1,
    width: "100%",
  },
  video: {
    backgroundColor: "#000",
    // height: width * (9 / 17.5),
    // width: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  buffering: {
    position: "absolute",
    ...StyleSheet.absoluteFill,
    justifyContent: "center",
    alignItems: "center",
  },
  controlOverlay: {
    position: "absolute",
    ...StyleSheet.absoluteFill,
    backgroundColor: "rgba(0,0,0,0.6)",
    justifyContent: "space-between",
  },
  fullScreenVideo: {
    height: width,
    width: height,
    backgroundColor: "black",
  },
});

export default Player;
